<div class="container">
  <h3 mat-dialog-title>Uwaga</h3>
  <p class="conf-dialog-caption">{{ data.text }}</p>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="1" (click)="confirm()">{{ successText }}</button>
    <button mat-button (click)="onNoClick()" tabindex="-1">{{ failText }}</button>
  </div>
</div>
  
<style>
  .conf-dialog-caption {
    font-size: 13px;
  }
</style>